import { render, staticRenderFns } from "./ProfileActivate.vue?vue&type=template&id=39bad4d4&"
import script from "./ProfileActivate.vue?vue&type=script&lang=js&"
export * from "./ProfileActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports